import Select from "react-select"
import React, { Fragment } from "react"
import {
  Button,
  Card,
  CardBody,
  Col,
  Row,
  Input,
  CardTitle,
  Label,
} from "reactstrap"
export const Filters = props => {
  const monthSeleceted =props.selectedMonth
  const {
    item,
    setItem,
    options,
    fromDate = "",
    toDate = "",
    setFromDate = () => {},
    setToDate = () => {},
  } = props;
  return (
      <Fragment>
        <Card>
          <CardBody>
            <CardTitle className="mb-4"></CardTitle>
            <Row>
              <Col lg={3}>
                <div className="row mb-4">
                  <Col sm={3} md={6} lg={10}>
                    <Label htmlFor="horizontal-firstname-Input">From</Label>
                    <Input
                        type="date"
                        className="form-control"
                        id="horizontal-firstname-Input"
                        onChange={e => {
                          setFromDate(e.target.value)
                        }}
                        value={fromDate}
                    />
                  </Col>
                </div>
              </Col>
              <Col lg={3}>
                <div className="row mb-4">
                  <Col sm={9} md={6} lg={10}>
                    <Label htmlFor="horizontal-firstname-Input">To</Label>
                    <Input
                        type="date"
                        className="form-control"
                        id="horizontal-email-Input"
                        onChange={e => {
                          setToDate(e.target.value)
                        }}
                        value={toDate}
                    />
                  </Col>
                </div>
              </Col>
              <Col lg={3}>
                <Label htmlFor="horizontal-firstname-Input">Type</Label>
                <Select
                    options={options}
                    maxMenuHeight={150}
                    classNamePrefix="select2-selection"
                    onChange={item => {
                      setItem(item.value)
                    }}
                    value={{ label: item, value: item }}
                />
              </Col>
              <Col lg={2}>
                <div className="row mt-4">
                  <Col sm={9} md={2} lg={2}></Col>
                  <Col sm={9} md={6} lg={10}>
                    <div>
                      <Button
                          type="button"
                          color="primary"
                          className="w-md"
                          onClick={() => {
                            // props.call()
                          }}
                      >
                        Submit
                      </Button>

                    </div>
                  </Col>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Fragment>
  )
}
